import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { Radar } from '@nivo/radar'

const Sword: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
	return (
    <svg version="1.1" {...props} xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" enableBackground={"new 0 0 504.231 504.231"}
	 viewBox="0 0 504.231 504.231">
<g>
	<g>
		<path d="M472.628,436.41l-56.821-56.814l17.809-17.809c6.361-6.361,8.844-15.633,6.516-24.321s-9.116-15.476-17.805-17.803
			c-8.689-2.328-17.96,0.157-24.321,6.518l-0.01,0.01l-74.872-74.66L495.206,79.935c1.394-1.388,2.255-3.222,2.434-5.18
			l5.934-65.287c0.226-2.482-0.663-4.935-2.426-6.696c-1.755-1.771-4.211-2.661-6.693-2.426l-65.287,5.934
			c-1.952,0.178-3.78,1.033-5.168,2.418L251.8,180.414L79.62,8.722c-1.386-1.384-3.213-2.239-5.164-2.418L9.157,0.344
			C6.675,0.12,4.222,1.009,2.46,2.771C0.698,4.533-0.19,6.986,0.034,9.468l5.959,65.303c0.179,1.959,1.041,3.792,2.434,5.18
			L180.49,251.523l-74.878,74.666l-0.008-0.008c-9.832-9.834-25.775-9.835-35.609-0.002c-9.834,9.832-9.834,25.775-0.002,35.609
			l17.809,17.809L30.981,436.41c-7.934,0.451-15.44,3.745-21.143,9.279c-13.11,13.11-13.11,34.365,0,47.475
			c13.11,13.11,34.365,13.11,47.475,0c5.718-5.745,9.138-13.383,9.615-21.475l56.482-56.486l17.805,17.805
			c6.359,6.362,15.63,8.849,24.319,6.522c8.69-2.326,15.478-9.111,17.808-17.8s-0.152-17.96-6.511-24.322l74.979-74.766
			l74.976,74.753l-0.006,0.006c-9.832,9.835-9.831,25.778,0.004,35.611c9.835,9.832,25.778,9.831,35.611-0.004l17.805-17.805
			l56.482,56.486c0.838,18.157,15.889,32.399,34.064,32.233c18.176-0.166,32.964-14.68,33.471-32.849
			C504.724,452.903,490.767,437.588,472.628,436.41z M22.436,70.213L17.67,17.984l52.242,4.762l170.002,169.519l-47.538,47.405
			L22.436,70.213z M45.444,481.295c-6.641,6.344-17.097,6.344-23.738,0c-4.802-4.801-6.239-12.021-3.641-18.295
			c2.598-6.273,8.719-10.364,15.509-10.364c6.79,0,12.911,4.09,15.509,10.364C51.683,469.274,50.246,476.494,45.444,481.295z
			 M62.411,452.466c-1.406-2.466-3.119-4.743-5.098-6.778c-2.042-1.979-4.346-3.67-6.847-5.025l49.203-49.197l11.869,11.869
			L62.411,452.466z M164.956,421.14c-3.28,3.275-8.593,3.275-11.873,0l-71.221-71.221c-3.259-3.282-3.25-8.582,0.021-11.852
			s8.571-3.278,11.852-0.017l35.609,35.611l0.392,0.391l0.053,0.08l0.079,0.053l29.15,29.152h0.001l5.933,5.934
			C168.222,412.551,168.224,417.857,164.956,421.14z M245.884,304.847l-0.022,0.014l-0.014,0.021l-80.885,80.657l-17.357-17.357
			l76.559-76.56c3.227-3.286,3.203-8.558-0.054-11.815s-8.529-3.28-11.815-0.054l-76.559,76.559l-18.256-18.256l80.821-80.595
			l0.019-0.012l0.012-0.018l59.38-59.213l0.034-0.023l0.022-0.033L433.706,22.722l52.238-4.746l-4.746,52.221l-175.875,175.38
			l-0.034,0.023l-0.022,0.033L245.884,304.847z M263.695,310.791l47.542-47.408l74.889,74.676l-18.255,18.253l-34.591-34.591
			c-3.286-3.227-8.558-3.203-11.815,0.053c-3.256,3.257-3.28,8.529-0.053,11.815l34.591,34.591l-17.347,17.345L263.695,310.791z
			 M350.526,421.14c-3.279,3.268-8.585,3.264-11.86-0.009c-3.274-3.273-3.28-8.579-0.013-11.86l5.886-5.885l0.073-0.049
			l29.203-29.201l0.006-0.004l0.004-0.006L403.953,344l0.058-0.086l5.864-5.865c3.278-3.279,8.592-3.28,11.871-0.002
			c3.279,3.278,3.28,8.592,0.002,11.871L350.526,421.14z M446.297,445.689c-1.98,2.035-3.693,4.312-5.098,6.779l-49.127-49.131
			l11.869-11.869l49.203,49.197C450.642,442.019,448.339,443.709,446.297,445.689z M481.903,481.295
			c-6.641,6.344-17.097,6.344-23.738,0c-4.802-4.801-6.239-12.021-3.641-18.295c2.598-6.273,8.719-10.364,15.509-10.364
			s12.911,4.09,15.509,10.364C488.142,469.274,486.705,476.495,481.903,481.295z"/>
	</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
	);
};

export {Sword};